module.exports = __webpack_public_path__ + "fonts/motiva-sans-medium.bc22cb3.otf";